module.exports = __webpack_public_path__ + "img/2710901.jpg";